var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 241 283",
    width: 241,
    height: 283,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#2563eb}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m190.8 71.9l-57.4 171.1h-27.4l-58-171.1v171.1h-24.6v-204.1h36.1l60.5 177.8 59.4-177.8h36.1v204.1h-24.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortLogo);
export default __webpack_public_path__ + "static/media/shortLogo.f53a1187f77154b0947e1db888b645fe.svg";
export { ForwardRef as ReactComponent };